document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initMarquesina();
  initGaleriaProducto();
  initVariantesProducto();
  initComparador();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-mt-contador'));
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var val = target * eased;
        el.textContent = (target % 1 !== 0) ? val.toFixed(1) : Math.round(val);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = (target % 1 !== 0) ? target.toFixed(1) : target;
      }
      requestAnimationFrame(step);
      obs.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  document.querySelectorAll('.mt-marquesina').forEach(function (track) {
    if (track.dataset.mtCloned) return;
    track.dataset.mtCloned = '1';
    var clone = track.innerHTML;
    track.insertAdjacentHTML('beforeend', clone);
  });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-mt-galeria-principal]');
  var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      if (!src || !main) return;
      main.style.opacity = '0';
      setTimeout(function () {
        main.setAttribute('src', src);
        main.style.opacity = '1';
      }, 150);
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activa'); });
      thumb.classList.add('mt-thumb-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = document.getElementById('mt-variantes-json');
  var selects = form.querySelectorAll('[data-mt-opcion]');
  if (!dataEl || !selects.length) return;
  var variantes = JSON.parse(dataEl.textContent);
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-comparado]');
  var botonEl = form.querySelector('[data-mt-boton-comprar]');

  function moneda(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' });
  }

  function actualizar() {
    var seleccion = Array.from(selects).map(function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = moneda(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = moneda(variante.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (variante.available) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.getAttribute('data-texto-disponible');
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.getAttribute('data-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (wrap) {
    var handle = wrap.querySelector('[data-mt-comparador-asa]');
    var after = wrap.querySelector('[data-mt-comparador-after]');
    if (!handle || !after) return;
    var dragging = false;

    function mover(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1) * 100;
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    handle.addEventListener('pointerdown', function (e) { dragging = true; handle.setPointerCapture(e.pointerId); });
    window.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('pointermove', function (e) { if (dragging) mover(e.clientX); });
    wrap.addEventListener('click', function (e) { mover(e.clientX); });
  });
}
